export default "__VITE_ASSET__edd30ec9__"